<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <!-- <Create
      :createDialog="categoryCreateDialog"
      @close="categoryCreateDialog = false"
      @submit="getCategory"
    ></Create> -->
    <v-card grid-list-md>
      <ModelTitle title="New Account" @close="close()" />
      <v-container>
        <v-row>
          <v-col cols="12" sm="12">
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <ImageView
                  :name="searchName"
                  field="product"
                  @submit="imageChange"
                />
                <!-- <v-card height="100%" min-height="100" outlined>
                  <v-hover v-if="Product.imageUrl" v-slot:default="{ hover }">
                    <v-img
                      height="100%"
                      aspect-ratio="1"
                      :src="Product.imageUrl"
                    >
                      <v-layout
                        v-if="hover"
                        column
                        fill-height
                        justify-center
                        align-center
                      >
                        <v-flex shrink>
                          <v-btn
                            @click="Product.imageUrl = null"
                            color="error"
                            fab
                            small
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-hover>
                  <v-img
                    v-else
                    height="100%"
                    src="https://www.esm.rochester.edu/uploads/NoPhotoAvailable-335x419.jpg"
                  >
                  </v-img>
                </v-card> -->
              </v-col>
              <v-col sm="12" md="9">
                <v-row align="center">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="Product.name"
                      :error-messages="nameErrors"
                      autofocus
                      :hide-details="nameErrors.length === 0"
                      outlined
                      @change="changeName"
                      @focus="$event.target.select()"
                      dense
                      label="Name"
                      ref="productName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      v-model="Product.price"
                      class="right-input"
                      label="Price"
                      outlined
                      dense
                      hide-details
                      @focus="$event.target.select()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Product Active"
                      hide-details
                      outlined
                      dense
                      v-model="Product.active"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Fee base product"
                      hide-details
                      outlined
                      dense
                      v-model="Product.isFee"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Public donation account"
                      hide-details
                      outlined
                      dense
                      v-model="Product.publicDonation"
                      @change="resetMerchant"
                    ></v-checkbox>
                  </v-col>
                  <!-- <v-col cols="12" sm="12">
                    <v-select
                      :items="Category"
                      clearable
                      :hide-details="selectCategoryError.length === 0"
                      :error-messages="selectCategoryError"
                      v-model="Product.CategoryId"
                      item-text="name"
                      outlined
                      dense
                      item-value="id"
                      label="Select Category"
                    >
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item @click="categoryCreateDialog = true">
                          <v-list-item-content>
                            <v-list-item-title
                              >Create New Category</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <!-- <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.cost"
              @focus="$event.target.select()"
              class="right-input"
              outlined
              hide-details
              dense
              label="Purchase Cost"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.price"
              class="right-input"
              label="Price"
              outlined
              dense
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.balance"
              class="right-input"
              hide-details
              disabled
              outlined
              dense
              @focus="$event.target.select()"
              label="Current Stock"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Track Inventory"
              hide-details
              outlined
              dense
              :disabled="trackInventory"
              v-model="Product.trackInventory"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Track Serial Number"
              hide-details
              outlined
              dense
              v-model="Product.trackSerialNumber"
            ></v-checkbox>
          </v-col> -->

          <!-- <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Remote Ordering"
              hide-details
              outlined
              dense
              v-model="Product.remoteOrder"
            ></v-checkbox>
          </v-col> -->
          <v-col v-if="Product.publicDonation" cols="12" sm="12" class="py-0">
            <v-select :loading="loading" item-value="id" item-text="name"
            single-line v-model="Product.MerchantAccountId"
            outlined dense :items="merchants"
            label="Select Merchant Account"></v-select>
          </v-col>
          <v-col cols="12" sm="12" class="py-0">
            <v-select :loading="loading" item-value="id" item-text="name"
            single-line v-model="Product.CategoryId"
            outlined dense :items="Category"
            label="Select Category"></v-select>
          </v-col>
          <v-col cols="12" sm="12" class="pt-0">
            <v-textarea
              counter="counter"
              hide-details
              outlined
              dense
              auto-grow
              v-model="Product.note"
              :label="$t('labels.description')"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>
      <v-card-actions>
        <!-- <MoreImage :imageResult="imageResult" @submit="imageChange" /> -->

        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import productService from "../service.js";
import categoryService from "@/modules/Product/Category/service";
import GlobalFunction from "@/mixins/GlobalFunction";
import merchantService from "@/modules/Merchant/service.js";
import ImageView from "@/components/Image/ImageView";

const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
// const Create = () => import("@/modules/Product/Category/components/Create");

export default {
  props: {
    createDialog: {
      default: false,
    },
  },
  name: "create-product",
  data() {
    return {
      categoryCreateDialog: false,
      Category: [],
      searchName: null,
      imageResult: null,
      selectedCategory: null,
      loading: false,
      dialog: false,
      trackInventory: false,
      merchants: [],
      Product: {
        name: null,
        note: null,
        imageUrl: null,
        price: 0,
        cost: 0,
        trackSerialNumber: false,
        balance: 0,
        trackInventory: true,
        active: true,
        MerchantAccountId: null,
        CategoryId: null,
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Product: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
  },
  components: {
    // MoreImage,
    ImageView,
    // Create,
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Product.name.$dirty) return errors;
      if (!this.$v.Product.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Product.name.minLength)
        errors.push("Field must be at least 4 characters long");
      return errors;
    },
  },
  watch: {
    Product: {
      handler(val) {
        if (val.trackSerialNumber) {
          this.Product.trackInventory = false;
          this.trackInventory = false;
        } else {
          this.trackInventory = false;
        }
      },
      deep: true,
    },
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getMerchanAccount()
        this.getCategory()
        this.$nextTick(() => {
          this.$refs.productName.focus();
        });
      }
    },
  },
  methods: {
    resetMerchant(){
      this.Product.MerchantAccountId = null
    },
    imageChange(val) {
      console.log("image change ", val);
      if (val) {
        this.Product.imageUrl = val;
      }
    },
    getMerchanAccount(){
      this.loading = true;
      merchantService.getAll().then(response => {
        
        this.loading = false;
        this.merchants = response.data
      }).catch(error => {
        this.loading = false;
        console.log('error getting merchants', error)
      })
    },
    changeName() {
      this.Product.name = this.properCase(this.Product.name);
      this.searchName = this.Product.name;
      // this.getimage(this.Product.name).then(response => {
      //   if (response.data) {
      //     this.imageResult = response.data;
      //     this.Product.imageUrl = response.data.imgUrl1;
      //   }
      // });
    },
    getimage(name) {
      return productService
        .getGooglePic({ name: name })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    getCategory() {
      this.loading = true;
      return categoryService.getAll().then((response) => {
        this.loading = false;
        this.Category = response.data;
        return response;
      }).catch(error => {
        this.loading = false;
        console.log('error getting merchants', error)
      });
    },
    empty() {
      this.Product = {
        name: null,
        note: null,
        price: 0,
        cost: 0,
        imageUrl: null,
        CategoryId: null,
        trackSerialNumber: false,
        balance: 0,
        trackInventory: false,
        active: true,
        MerchantAccountId: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.imageUrl) {
          this.Product.image = {
            imageUrl: this.imageUrl,
            TypeId: 9,
          };
        }
        this.loading = true;
        return productService
          .create(this.Product)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Product is created",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
